import {
  InspectorPortalAssignmentSummary,
  ViewingsDispatchRequest,
} from "@/schemas";
import { InspectorPortalSnapshot, PortalAssignment } from "./types";

type LegacyRequestFields = Partial<
  Pick<
    ViewingsDispatchRequest,
    | "acceptedDate"
    | "activityTimeline"
    | "assignedDispatcherId"
    | "assignedInspectorName"
    | "flags"
    | "lastContactedAt"
    | "offeredDate"
    | "outreach"
    | "ownerName"
    | "title"
  >
>;

export function todayDateString(): string {
  return new Date().toISOString().slice(0, 10);
}

export function clonePortalData(
  data: InspectorPortalSnapshot,
): InspectorPortalSnapshot {
  return JSON.parse(JSON.stringify(data)) as InspectorPortalSnapshot;
}

export function toViewingRequest(
  assignment: PortalAssignment,
  inspectorId: string,
): ViewingsDispatchRequest {
  const legacyFields = assignment as PortalAssignment & LegacyRequestFields;

  return {
    id: assignment.id,
    evalionId: assignment.evalionId,
    title: legacyFields.title ?? assignment.evalionId,
    addressLine: assignment.addressLine,
    ownerName: assignment.customerLabel ?? legacyFields.ownerName ?? "-",
    lifecycleStatus: assignment.lifecycleStatus,
    deadlineDate: assignment.deadlineDate,
    offeredDate: legacyFields.offeredDate ?? null,
    acceptedDate: legacyFields.acceptedDate ?? null,
    assignedDispatcherId: legacyFields.assignedDispatcherId ?? null,
    assignedDispatcherName: assignment.dispatcherContact?.name ?? null,
    assignedInspectorId: inspectorId,
    assignedInspectorName: legacyFields.assignedInspectorName ?? null,
    lastContactedAt: legacyFields.lastContactedAt ?? null,
    flags: legacyFields.flags ?? {
      noMatch: false,
      waitingOver48h: false,
      acceptedAfterDeadline: false,
      reassignedInvalidation: false,
    },
    activityTimeline: legacyFields.activityTimeline ?? [],
    inspectionType: assignment.inspectionType,
    productType: assignment.productType,
    distanceKm: assignment.approximateDistanceKm ?? undefined,
    specialNotes: assignment.inspectorInstructions ?? undefined,
    outreach: legacyFields.outreach,
  };
}

export function updateAssignmentFromRequest(
  assignment: InspectorPortalAssignmentSummary,
  request: ViewingsDispatchRequest,
): InspectorPortalAssignmentSummary {
  return {
    ...assignment,
    ...request,
    lifecycleStatus: request.lifecycleStatus,
    scheduledFor:
      request.lifecycleStatus === "scheduled"
        ? request.deadlineDate
        : assignment.scheduledFor,
  };
}
